import {Button, UnstableCard as Paper} from '@logistics-frontend/blocks'
import {spacing} from '@logistics-frontend/blocks/theme/theme'
import React from 'react'

import {useAction} from '../../actions'
import {FloatingBox, StickyTo} from '../../components/FloatingBox'
import {useStatusContext} from '../../contexts/StatusContext'
import {renderWidget} from '..'
import {WidgetPropsByType, WidgetType} from '../types'
import * as classes from './ActionButton.classes'

const ActionButtonWidgetComponent = ({
  button_size,
  loading_style,
  normal_style,
  action,
}: WidgetPropsByType<WidgetType.ACTION_BUTTON>): React.ReactElement => {
  const {isFetching} = useStatusContext()
  const {
    ActionComponent,
    actionFns: {triggerAction},
  } = useAction(action)

  const currStyle = isFetching ? loading_style : normal_style

  return (
    <FloatingBox className={classes.floatingWrapper} height={spacing(13.25)} stickyTo={StickyTo.BLOCK_END}>
      <Paper className={classes.actionButtonWrapper} padding="S" radius="L">
        <Button
          disabled={!currStyle.enabled}
          justifyContent={currStyle.slot.align}
          onPress={triggerAction}
          size={button_size}
          variant="action"
          fullWidth
        >
          {currStyle.slot.title.items.map(renderWidget)}

          {ActionComponent}
        </Button>
      </Paper>
    </FloatingBox>
  )
}

export const ActionButtonWidget = React.memo(ActionButtonWidgetComponent)
